
import * as React from "react";
import CountDownComp from "../global/CountDownComp";
import { ISetUrl } from "../../AppMain";
import { IActiveOrders } from "../../interfaces/IOrder";
import DateTool from "../../../avernus/datetool/source/DateTool";
import { Api } from "../../lib/Api";
import { Lng } from "../../../languages/Languages";
import Header from "../Header";

interface ISelectProfessionalCategoryProps {
    setUrl              :ISetUrl
    changed             : Function
}

interface ISelectProfessionalCategoryState {
    offerTypeOptions: Array<IOfferTYpeOption>
}

interface IInitResult{
    offerTypeOptions: Array<IOfferTYpeOption>
}

interface IOfferTYpeOption{
    name: string
    id:Number
    img: string
}

export default class SelectProfessionalCategory extends React.Component<ISelectProfessionalCategoryProps, ISelectProfessionalCategoryState>{

    constructor(props:ISelectProfessionalCategoryProps){
        super(props);
        this.state = {
            offerTypeOptions:   []
        };

        this.init();
    }


    private init(){
        Api.call('/restaurants/offers/init', {
            restaurantId: 0
        }, (result:IInitResult) =>{
            this.setState({
                offerTypeOptions: result.offerTypeOptions,
            });
        } );
    }

    private changeCategory(item : IOfferTYpeOption){
        this.props.changed(item);
    }


    render() {

        return (
            <>
                <Header
                    setUrl={this.props.setUrl}
                    getActiveOrders={Api.isFrontUser()}
                    title={'Please select a service'}
                />
                <div className="content_section container">
                    <div className={"h1_box"}>
                        <h1>
                            Please select a service
                        </h1>
                    </div>
                    <section className="pofessional_categories">
                        <div className = "row">
                            { this.state.offerTypeOptions.map((item, key:number) => (
                                <div className="col-6 category-block" onClick = {(e) => this.changeCategory(item)}>
                                    <img src = {item.img}/>
                                    <p className = "service-name">{ item.name }</p>
                                </div>
                                ))}
                        </div>
                    </section>
                </div>
            </>
        );
    }
}
